module.exports = __webpack_public_path__ + "img/arrow(back).95c05730.svg";